/**
 * Storezone — Seller (POS) Routes
 *
 * All routes here are wrapped in SellerLayout and
 * require seller membership + branch assignment.
 */

import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { SellerLayout } from '@/layouts/SellerLayout'
import { LoadingPage } from '@/components/states/LoadingPage'

const SellerDashboard = lazy(() =>
  import('@/pages/seller/SellerDashboard').then((m) => ({
    default: m.SellerDashboard,
  })),
)

const POSPage = lazy(() =>
  import('@/pages/seller/pos/POSPage').then((m) => ({
    default: m.POSPage,
  })),
)

const SellerPaymentsPage = lazy(() =>
  import('@/pages/seller/payments/SellerPaymentsPage').then((m) => ({
    default: m.SellerPaymentsPage,
  })),
)

const SellerProductsPage = lazy(() =>
  import('@/pages/seller/products/SellerProductsPage').then((m) => ({
    default: m.SellerProductsPage,
  })),
)

const SellerOrdersPage = lazy(() =>
  import('@/pages/seller/orders/SellerOrdersPage').then((m) => ({
    default: m.SellerOrdersPage,
  })),
)

const SellerCustomersPage = lazy(() =>
  import('@/pages/seller/customers/SellerCustomersPage').then((m) => ({
    default: m.SellerCustomersPage,
  })),
)

const SellerCustomerProfilePage = lazy(() =>
  import('@/pages/seller/customers/SellerCustomerProfilePage').then((m) => ({
    default: m.SellerCustomerProfilePage,
  })),
)

export function SellerRoutes() {
  return (
    <SellerLayout>
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          {/* Default → POS */}
          <Route index element={<POSPage />} />

          {/* Core Seller Features */}
          <Route path="pos"       element={<POSPage />} />
          <Route path="products"  element={<SellerProductsPage />} />
          <Route path="orders"    element={<SellerOrdersPage />} />
          <Route path="customers" element={<SellerCustomersPage />} />
          <Route path="customers/:id" element={<SellerCustomerProfilePage />} />
          <Route path="dashboard" element={<SellerDashboard />} />
          <Route path="payments"  element={<SellerPaymentsPage />} />

          {/* Catch-all within seller zone stays in seller zone */}
          <Route path="*" element={<Navigate to="/pos" replace />} />
        </Routes>
      </Suspense>
    </SellerLayout>
  )
}
